import React, {useContext, useEffect} from 'react'
import NavBar from './NavBar' 
import SiteContext from "../context/SiteContext"

const IRSNavBar = () => {

  const {site, toggleNav, submitSearch } = useContext(SiteContext)

  //@todo combine navItems, searchItems and navItemsIsOpen into one function
  /** grab only the link items */
  const navItems = site.navBar && Object.values(site.navBar).map(item => {
    return item.type === "link" ? item.key : ""
  })
  const cleanNav = navItems.filter(entry => entry.trim() !== '')

  /** grab the search item */
  const searchItems = site.navBar && Object.values(site.navBar).map(item => {
    return item.type === "search" ? item.key : ""
  })
  const cleanSearchItems = searchItems.filter(entry => entry.trim() !== '')

  /** grab the open nav item link */
  const navItemsIsOpen = site.navBar && Object.values(site.navBar).map(item => {
    return item.type === "link" ? item.isOpen : ""
  })
  const cleanNavIsOpen = navItemsIsOpen.filter(entry => entry !== '')

  useEffect(() => {
    const handleKeyDown = (ev) => {
    
      const activeElement = document.activeElement

      if (cleanNav.includes(activeElement.id)) {

        if(ev.keyCode === 32) {
          toggleNav(document.activeElement.id)
          ev.preventDefault()
        }

        if(ev.keyCode === 40) {
          toggleNav(document.activeElement.id)
          ev.preventDefault()
        }

      }

      if(activeElement.id === "navBarSearchButton" && ev.keyCode === 32) {
        submitSearch("navBarSearchForm")
      }

      if(activeElement.id === "headerSearchButton" && ev.keyCode === 32) {
        submitSearch("headerSearchForm")
      }
    } 

    window.addEventListener("keydown", handleKeyDown)

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [cleanNavIsOpen, cleanNav, toggleNav, submitSearch])

  useEffect(() => {
    const handleKeyUp = (ev) => {
      const activeElement = document.activeElement
      ev.preventDefault()
      ev.stopPropagation()

      if (cleanNav.includes(activeElement.id)) {
        if(ev.keyCode === 9) {
          cleanNavIsOpen.forEach(item => {
            if(item) {
              toggleNav(activeElement.id)
            }
          })
        }
      }

      if(cleanSearchItems.includes(activeElement.id)) {
        toggleNav(null)
      }
    } 

    window.addEventListener("keyup", handleKeyUp)

    return () => window.removeEventListener("keyup", handleKeyUp);
  }, [cleanNavIsOpen, cleanNav, cleanSearchItems, toggleNav])

  return (
    <NavBar
      items={site.navBar} 
      headerNavItems={site.headerNavItems} 
    />
  )
}

export default IRSNavBar
